(() => {
  const qs = (sel, root = document) => root.querySelector(sel);
  const qsa = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  const toggleMenu = () => {
    const drawer = qs('[data-nq-drawer]');
    const toggle = qs('[data-nq-menu-toggle]');
    if (!drawer || !toggle) return;
    const open = drawer.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', String(open));
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-nq-menu-toggle]');
    if (toggle) {
      event.preventDefault();
      toggleMenu();
    }
  });

  qsa('[data-nq-qty]').forEach((wrap) => {
    const input = qs('input', wrap);
    wrap.addEventListener('click', (event) => {
      const btn = event.target.closest('button');
      if (!btn || !input) return;
      const delta = Number(btn.dataset.delta || 0);
      const next = Math.max(1, (Number(input.value) || 1) + delta);
      input.value = String(next);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  qsa('[data-nq-gallery]').forEach((gallery) => {
    const main = qs('[data-nq-gallery-main]', gallery);
    gallery.addEventListener('click', (event) => {
      const thumb = event.target.closest('[data-src]');
      if (!thumb || !main) return;
      main.src = thumb.dataset.src;
    });
  });

  const openCart = () => {
    const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
    if (trigger) {
      trigger.click();
      return;
    }
    const drawer = document.querySelector('#cart-drawer');
    if (drawer && typeof drawer.showDialog === 'function') drawer.showDialog();
  };

  const addToCart = async (id, quantity) => {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id, quantity }] }),
    });
    if (!response.ok) throw new Error('add_failed');
    return response.json();
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-nq-product-form]');
    if (!form) return;
    if (event.submitter && event.submitter.getAttribute('name') === 'checkout') return;

    event.preventDefault();
    const id = Number(form.querySelector('[name="id"]')?.value || 0);
    const quantity = Number(form.querySelector('[name="quantity"]')?.value || 1);
    const button = event.submitter || form.querySelector('[type="submit"]');
    if (!id) return;

    const original = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = button.dataset.adding || 'Adding...';
    }

    try {
      await addToCart(id, quantity);
      if (button) button.textContent = button.dataset.added || 'Added';
      openCart();
    } catch (error) {
      if (button) button.textContent = button.dataset.error || 'Try again';
    } finally {
      if (button) {
        setTimeout(() => {
          button.disabled = false;
          button.textContent = original;
        }, 1400);
      }
    }
  });

  document.addEventListener('click', async (event) => {
    const quick = event.target.closest('[data-nq-quick-add]');
    if (!quick) return;
    event.preventDefault();
    const id = Number(quick.dataset.nqQuickAdd);
    if (!id) return;
    const original = quick.textContent;
    quick.disabled = true;
    quick.textContent = quick.dataset.adding || 'Adding...';
    try {
      await addToCart(id, 1);
      quick.textContent = quick.dataset.added || 'Added';
      openCart();
    } catch (error) {
      quick.textContent = quick.dataset.error || 'Try again';
    } finally {
      setTimeout(() => {
        quick.disabled = false;
        quick.textContent = original;
      }, 1400);
    }
  });
})();
